// AWS Cognito Configuration
// Uses environment variables for different environments (dev, test, production)

const region = import.meta.env.VITE_AWS_REGION

// Cognito domain prefix (without the full auth URL)
const cognitoDomainPrefix = import.meta.env.VITE_COGNITO_DOMAIN
const awsConfig = {
  region,
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
  authenticationFlowType: 'CUSTOM_AUTH' as const, // For OTP-based passwordless authentication
  oauth: {
    // Full Cognito domain for Hosted UI
    domain: `${cognitoDomainPrefix}.auth.${region}.amazoncognito.com`,
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: import.meta.env.VITE_REDIRECT_SIGN_IN || 'http://localhost:3000/',
    redirectSignOut: import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:3000/',
    // OAuth callback path for handling authorization code
    callbackPath: '/callback',
    responseType: 'code' as const
  }
}

export default awsConfig
